<template>
    <div>
        <h5 class="mt-3">Jackpot Leaderboard</h5>
        <b-table-simple bordered striped class="mb-0">
            <thead>
                <tr>
                    <th>Place</th>
                    <th>Payout</th>
                    <th>Rewards</th>
                    <th>Contender</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    :key="leaderboardUser.user.id"
                    v-for="(leaderboardUser, index) in jackpot.leaderboardUsers"
                >
                    <td class="text-center" style="width: 1%">
                        {{ index + 1 }}
                    </td>
                    <td>
                        <coin-badge
                            v-if="jackpot.payouts[index] != null"
                            :amount="jackpot.payouts[index]"
                        />
                    </td>
                    <td>{{ leaderboardUser.count }}</td>
                    <td>
                        <img class="mr-1" :src="leaderboardUser.user.flagUrl" />
                        <b-badge
                            v-if="onboardingUser.id === leaderboardUser.user.id"
                            variant="primary"
                            pill
                        >
                            Me
                        </b-badge>
                        <b-badge v-else variant="light" pill class="border">
                            {{ leaderboardUser.user.codename }}
                        </b-badge>
                    </td>
                </tr>
            </tbody>
        </b-table-simple>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    props: ["jackpot"],
};
</script>